export default "__VITE_ASSET__CM$F9c$J__"